export default __webpack_public_path__ + "static/media/nutrihogs-logo.22d3376a.png";